// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"422":"112e8deb","615":"76ce0c88"}[chunkId] + ".css";
};